export const templateKey = {
    label: "Template Key",
    name: "templateKey",
    widget: "hidden",
    default: "about-page",
}

export const headImage = { label: "Head Image", name: "headImage", widget: "image" }
export const title = { label: "Title", name: "title", widget: "string" }
export const body = { label: "Body", name: "body", widget: "markdown" }


export const arrangements = {
    label: "Arrangements",
    name: "arrangements",
    widget: "list",
    fields:
        [
            { label: "Name", name: "name", widget: "string" },
            { label: "PDF", name: "file", widget: "file" },
            { label: "Description", name: "description", widget: "string" },
        ],
}
